<template>
  <div class="loading-wrap">
    <van-loading
      type="spinner"
      vertical
      size="48px"
    >
      数据加载中...
    </van-loading>
  </div>
</template>
<script>
export default {
  components: {},
  props: {},
  data() {
    return {}
  },
  watch: {},
  methods: {}
}
</script>
<style lang="less" scoped>
.loading-wrap {
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  background-color: rgba(0, 0, 0, 0.7);
}
</style>
